import React, { useEffect, useRef, useState } from "react";

import { useStateValue } from "../../../StateProvider";
import { useForm } from "react-hook-form";
import {
  addTaskSubTask,
  doneSubTask,
  getAddNewTaskDetail,
  getSubTaskFormDetail,
  getTaksSubTask,
  incompleteSubTask,
  updateTaksSubTask,
} from "../../../apiCall";
import toast from "react-hot-toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DecodeAprxDuration from "../../../utils/DecodeAprxDuration";
import EncodeAprxDuration from "../../../utils/EncodeAprxDuration";
import { ConfirmationModal } from "../../../components/Modals/ConfirmationModal";
import Attachment from "../../Attachment/Attachment";
import { useQuery } from "@tanstack/react-query";
import { validateNoBlankSpaces } from "../../../utils/formValidation";

const AddUpdateSubtask = ({ setActiveTab, editSubTaskData }) => {
  const [tab, setTab] = useState("information");
  const [{ userInfo }, dispatch] = useStateValue();
  const { taskId, subtaskId, projectId, pName, tName } = useParams();
  const [tID, setTId] = useState("");
  const [projectName, setProjectName] = useState("");
  const [taskName, setTaskName] = useState("");
  const [isSubtaskDone, setIsSubtaskDone] = useState(false);
  const [actionSubtaskStatus, setActionSubtaskStatus] = useState(false);

  const navigate = useNavigate();
  //******************************************attachment start **************************************************
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [isAddAttachments, setIsAddAttachments] = useState(false);
  const [title, setTitle] = useState("Add Sub-Task");
  const formRef = useRef(null);
  const updateUrl = (newPath) => {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);

    // Construct new URL
    // const newPath = '/update/task/31';
    const newUrl = `${newPath}?${searchParams.toString()}`;

    // Navigate to the new URL
    navigate(newUrl);
  };

  const handleExternalSubmit = () => {
    if (isSubtaskDone) {
      setTab("attachments");
      setTitle(subtaskId ? "Update Sub-Task" : "Add Sub-Task");
    } else {
      if (tab === "information") {
        setIsAddAttachments(true);
        if (formRef.current) {
          setTimeout(() => {
            formRef.current.dispatchEvent(
              new Event("submit", { cancelable: true, bubbles: true })
            );
          }, 100);
        }
      } else {
        setTab("attachments");
        setTitle(subtaskId ? "Update Sub-Task" : "Add Sub-Task");
      }
    }
  };

  //******************************************attachment end **************************************************

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      AprxDays: 0,
      AprxHours: 0,
      AprxMinutes: 0,
    },
  });
  const watchedFields = watch();

  const onSubmit = async (data) => {
    if (
      // (parseInt(data?.AprxDays) === 0 || data?.AprxDays === "") &&
      // (parseInt(data?.AprxMinutes) === 0 || data?.AprxMinutes === "") &&
      // (parseInt(data?.AprxHours) === 0 || data?.AprxHours === "")
      false
    ) {
      toast.error("Days and hours cannot both be 0.");
    } else {
      dispatch({ type: "SET_LOADING", status: true });
      const totalDays = EncodeAprxDuration(
        data?.AprxDays === "" ? 0 : data?.AprxDays,
        data?.AprxHours === "" ? 0 : data?.AprxHours,
        data?.AprxMinutes === "" ? 0 : data?.AprxMinutes
      );
      data.Duration = totalDays;
      if (data.OrdNo === "") {
        delete data.OrdNo;
      }
      delete data.AprxDays;
      delete data.AprxHours;
      delete data.AprxMinutes;
      if (subtaskId) {
        const re = await updateTaksSubTask(subtaskId, data);
        if (re?.status === 200) {
          console.log(actionSubtaskStatus, "********************");
          if (actionSubtaskStatus) {
            handleConfirmationShow();
            setActionSubtaskStatus(false);
          } else if (isAddAttachments) {
            setTab("attachments");
            setTitle(subtaskId ? "Update Sub-Task" : "Add Sub-Task");
            setIsAddAttachments(false);
          } else {
            navigateToTaskWithId(subtaskId);
            reset();
            toast.success(re?.data?.message);
          }
        } else if (re?.response) {
          toast.error(re?.response?.data?.message);
        }
      } else {
        const re = await addTaskSubTask(tID, data);
        if (re?.status === 201) {
          if (actionSubtaskStatus) {
            handleConfirmationShow();
            setActionSubtaskStatus(false);
          } else if (isAddAttachments) {
            setTab("attachments");
            updateUrl(`/update/task/subtask/${re?.data?.data?.ID}`);
            setTitle(subtaskId ? "Update Sub-Task" : "Add Sub-Task");

            setIsAddAttachments(false);
          } else {
            navigateToTaskWithId(re.data.data.ID);
            reset();
            toast.success(re?.data?.message);
          }
        } else if (re?.response) {
          toast.error(re?.response?.data?.message);
        }
      }
      dispatch({ type: "SET_LOADING", status: false });
    }
  };

  const handelStatusChange = (e) => {
    if (e.target.checked) {
      setActionSubtaskStatus(true);
      // handleConfirmationShow();
      setFunHandler({
        fun: doneSubTsakStatus,
        id: subtaskId,
        title: "change sub task status to done",
      });
      if (formRef.current) {
        setTimeout(() => {
          formRef.current.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
        }, 100);
        // formRef.current.dispatchEvent(
        //   new Event("submit", { cancelable: true, bubbles: true })
        // );
      }
    } else {
      setActionSubtaskStatus(true);

      // handleConfirmationShow();
      setFunHandler({
        fun: incompleteSubTsakStatus,
        id: subtaskId,
        title: "change sub task status to Incomplete",
      });
      if (formRef.current) {
        setTimeout(() => {
          formRef.current.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
        }, 100);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: "SET_LOADING", status: true });
      const re = await getTaksSubTask(subtaskId);
      if (re?.status === 200) {
        setValue("TaskTranID", re.data?.TaskTmplID);
        setTId(re.data?.TaskTranID);
        setValue("OrdNo", re.data?.OrdNo);
        setValue("Name", re.data?.Name);
        setValue("Dscr", re.data?.Dscr);
        setValue("SubTaskLead", re?.data?.SubTaskLead);
        setValue("ParentTaskLead", re?.data?.parent_task_lead);
        const [days, hours, minutes] = DecodeAprxDuration(re?.data?.Duration);
        setValue("AprxDays", days);
        setValue("AprxHours", hours);
        setValue("AprxMinutes", minutes);
        setValue("AllocBy", re.data?.AllocBy);
        setAttachmentCount(re.data?.attachments_no);

        if (re.data?.Status.text === "Done") {
          setIsSubtaskDone(true);
        }
        // setProjectName(re.data?.parent_project_template_name);
        setTaskName(re.data?.parent_task_name);
      } else if (re?.response) {
        toast.error(re?.response?.data?.message);
      }
      dispatch({ type: "SET_LOADING", status: false });
    };
    if (subtaskId) {
      fetchData();
    }
  }, [subtaskId]);

  useEffect(() => {
    if (taskId) {
      console.log("setTId", setTId);
      setValue("TaskTranID", taskId);
      setTId(taskId);
    }
    if (pName) {
      setProjectName(pName);
    }
    if (tName) {
      setTaskName(tName);
    }
  }, [taskId, tName, pName]);
  console.log(watchedFields.SubTaskLead === userInfo?.user_code);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (tID && !subtaskId) {
          dispatch({ type: "SET_LOADING", status: true });
          const re = await getSubTaskFormDetail(tID);
          console.log(re);
          if (re?.status === 200) {
            setValue("OrdNo", parseInt(re?.data?.data?.OrdNo));
            setTaskName(re?.data?.data?.task_name);
          } else if (re?.response) {
            toast.error(re?.response?.data?.message);
          }
          dispatch({ type: "SET_LOADING", status: false });
        }
      } catch {}
    };
    fetchData();
  }, [tID, subtaskId]);
  // ************************************************************* subtask done **********************************
  const doneSubTsakStatus = async (id) => {
    try {
      const response = await doneSubTask(id);
      console.log(response);
      if (response?.status === 200) {
        toast.success(response.data.message);
        setIsSubtaskDone(true);
        navigateToTaskWithId(id);
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const incompleteSubTsakStatus = async (id) => {
    try {
      const response = await incompleteSubTask(id);
      console.log(response);
      if (response?.status === 200) {
        // refetch();
        setIsSubtaskDone(false);

        toast.success(response.data.message);
        navigateToTaskWithId(id);
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [subTaskStatus, setSubtaskStatus] = useState("Pending");
  const [funHandler, setFunHandler] = useState();
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userFilter = searchParams.get("user_filter"); // Replace 'param1' with your parameter name
  const statusFilter = searchParams.get("status_filter");
  const searchFilter = encodeURIComponent(searchParams.get("search_filter"));
  const projectUserFilter = searchParams.get("project_user_filter"); // Replace 'param1' with your parameter name
  const projectStatusFilter = searchParams.get("project_status_filter");
  const projectSearchFilter = encodeURIComponent(
    searchParams.get("project_search_filter")
  );
  const taskStatus = searchParams.get("task_status");
  const project = searchParams.get("project_name");
  const taskType = searchParams.get("task_type");
  const userCode = searchParams.get("user_code");

  const navigateToTaskWithId = (subtaskId) => {
    if (statusFilter && userFilter) {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/${tID}?project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&subTaskId=${subtaskId}&status_filter=${statusFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    } else if (statusFilter) {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/${tID}?project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&subTaskId=${subtaskId}&status_filter=${statusFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    } else if (userFilter) {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/${tID}?project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&subTaskId=${subtaskId}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    } else {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/${tID}?project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&subTaskId=${subtaskId}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    }
  };
  const navigateToTaskWithoutId = () => {
    if (statusFilter && userFilter) {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/${tID}?project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&status_filter=${statusFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    } else if (statusFilter) {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/${tID}?project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&status_filter=${statusFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    } else if (userFilter) {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/${tID}?project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    } else {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/${tID}?project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    }
  };
  useEffect(() => {
    if (subtaskId && tab === "information") {
      setTitle("Update Sub-Task");
    }
    if (!subtaskId && tab === "information") {
      setTitle("Add Sub-Task");
    }
  }, [subtaskId]);
  useEffect(() => {
    if (!subtaskId) {
      setValue("AllocBy", userInfo?.user_code);
    }
  }, [setValue, userInfo, subtaskId]);
  useEffect(() => {
    console.log(taskStatus === "Cancelled");
    if (taskStatus === "Done" || taskStatus === "Cancelled") {
      setSubtaskStatus(taskStatus);
    } else {
      if (isSubtaskDone) {
        setSubtaskStatus("Done");
      } else {
        setSubtaskStatus("Pending");
      }
    }
  }, [taskStatus, isSubtaskDone]);
  const isSubtaskDisabled = () => {
    if (
      subTaskStatus === "Cancelled" ||
      subTaskStatus === "Done" ||
      (subtaskId &&
        userInfo?.user_code !== watchedFields?.SubTaskLead &&
        userInfo?.user_code !== watchedFields?.ParentTaskLead)
    ) {
      return true;
    }
    return false;
  };

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["new-stask-form-data"],
    // enabled,
    queryFn: async () => {
      // Perform the API call to fetch company info
      try {
        dispatch({ type: "SET_LOADING", status: true });

        const response = await getAddNewTaskDetail(projectId);
        if (response?.status === 200) {
          setFormDefaultData(response.data.data);
        } else if (response?.response) {
          toast.error(response.response.data.status);
        }

        dispatch({ type: "SET_LOADING", status: false });
        return response;
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
      }
    },
  });
  const [formDefaultData, setFormDefaultData] = useState(
    data?.status === 200 ? data.data.data : {}
  );
  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area mb-10">
        <div className="container-fluid ">
          <div className="mx-n6 mt-n6 pt-6 mb-6 header">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                {/* Page header */}
                <div
                  className="d-lg-flex
 align-items-center justify-content-between  px-6"
                >
                  {/* <div className="mb-0 mb-lg-0 w-100"> */}
                  <div className="d-flex align-items-center w-100">
                    <div className="d-flex align-items-center justify-content-between w-100">
                      <h1 className="mb-0 h3 ">
                        {title}
                        {/* {subtaskId ? "Update Sub-Task" : "Add Sub-Task"} */}
                      </h1>
                      <div lassName="status ">
                        <div
                          className="mb-0"
                          style={{ fontSize: "20px", fontWeight: "bold" }}
                        >
                          {subTaskStatus}
                        </div>
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div> */}
                <div className="col-12 d-flex justify-content-between px-6">
                  {/* nav  */}
                  <ul className="nav nav-lb-tab ">
                    <li className="nav-item ms-0 me-3">
                      <div
                        role="button"
                        // className="nav-link active "
                        className={`${
                          tab === "information"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => {
                          setTab("information");
                          setTitle(
                            subtaskId ? "Update Sub-Task" : "Add Sub-Task"
                          );
                        }}
                      >
                        Information
                      </div>
                    </li>
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "attachments"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => {
                          handleExternalSubmit();
                        }}
                      >
                        Attachments
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-12px" }}
                      >
                        {attachmentCount}
                      </div>
                    </li>
                    {/* <li className="nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "notifications"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => setTab("notifications")}
                      >
                        Notifications
                      </div>
                    </li> */}
                  </ul>
                  {/* <div className="status fs-3">
                    <h3>{subTaskStatus}</h3>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              {/* <div className="mb-5">
                <h3 className="mb-0 ">Add Staff</h3>
              </div> */}
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-12">
                {/* card */}
                {(() => {
                  switch (tab) {
                    case "information":
                      return (
                        <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                          <div className="card mb-5">
                            {/* card body */}
                            <div
                              className="card-body"
                              style={{ padding: "10px" }}
                            >
                              {/* form */}
                              {project && (
                                <div className="row">
                                  {/* form group */}
                                  <div className="mb-4 col-md-12 col-12">
                                    <label className="form-label">
                                      Project Name:
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      // placeholder="Enter ID"
                                      // {...register("TaskTmplID", {})}
                                      disabled
                                      value={project}
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="row">
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Task Name:
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    // placeholder="Enter ID"
                                    // {...register("TaskTmplID", {})}
                                    disabled
                                    value={taskName}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="mb-4 col-md-4 col-12">
                                  <label className="form-label">
                                    Ord No:{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter ord no"
                                    disabled={isSubtaskDisabled()}
                                    {...register("OrdNo", {
                                      required: "Ord No is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.OrdNo && (
                                    <div className="error">
                                      {errors.OrdNo.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-12">
                                  <label className="form-label">
                                    Name <span className="text-danger">*</span>
                                  </label>
                                  <div className="d-flex ">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter name"
                                      disabled={isSubtaskDisabled()}
                                      {...register("Name", {
                                        required: "Name is required",
                                        validate: validateNoBlankSpaces,
                                      })}
                                    />

                                    <div className="ps-1 m-auto">
                                      {" "}
                                      <strong>
                                        {subtaskId ? subtaskId : "ID"}
                                      </strong>
                                    </div>
                                  </div>
                                  {errors.Name && (
                                    <div className="error">
                                      {errors.Name.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-12">
                                  <label className="form-label">
                                    Allocate By
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <select
                                    value={watchedFields.AllocBy}
                                    disabled
                                    // disabled={
                                    //   !(
                                    //     isAdmin(userInfo) &&
                                    //     taskStatus === "Pending"
                                    //   )
                                    // }
                                    className="form-select"
                                    {...register("AllocBy", {
                                      required: "AllocBy is required",
                                    })}
                                  >
                                    <option value="">Set Allocate By</option>
                                    {(formDefaultData?.users_list
                                      ? !formDefaultData?.users_list.includes(
                                          watchedFields.AllocBy
                                        )
                                      : false) && (
                                      <option value={watchedFields.AllocBy}>
                                        {" "}
                                        {watchedFields.AllocBy}
                                      </option>
                                    )}
                                    {formDefaultData?.users_list?.map(
                                      (item) => (
                                        <option value={item}>{item}</option>
                                      )
                                    )}
                                  </select>
                                  {/* <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Allocate By."
                                    disabled
                                    {...register("AllocBy", {
                                      // required: "Approx Days is required",
                                    })}
                                  /> */}

                                  {errors.AllocBy && (
                                    <div className="error">
                                      {errors.AllocBy.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                {/* <div className="mb-4 col-md-5 col-12">
                                  <label className="form-label">Type</label>
                                  <select
                                    className="form-select"
                                    {...register("Type", {
                                      required: "Type is required",
                                    })}
                                  >
                                    <option value="">Set Type</option>
                                    {userTypeOption.map((item) => (
                                      <option value={item.id}>
                                        {item.value}
                                      </option>
                                    ))}
                                  </select>
                                  {errors.Type && (
                                    <div className="error">
                                      {errors.Type.message}
                                    </div>
                                  )}
                                </div> */}
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Description{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <textarea
                                    type="text"
                                    rows={5}
                                    className="form-control"
                                    placeholder="Enter description."
                                    disabled={isSubtaskDisabled()}
                                    {...register("Dscr", {
                                      // required: "description is required",
                                    })}
                                  ></textarea>
                                  {errors.Dscr && (
                                    <div className="error">
                                      {errors.Dscr.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Approx Days{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Days"
                                    disabled={isSubtaskDisabled()}
                                    {...register("AprxDays", {
                                      // required: "Approx Days is required",
                                    })}
                                  />
                                  {errors.AprxDays && (
                                    <div className="error">
                                      {errors.AprxDays.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Approx Hours{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Hours"
                                    disabled={isSubtaskDisabled()}
                                    {...register("AprxHours", {
                                      max: {
                                        value: 23,
                                        message:
                                          "approx hours must be less than 24",
                                      },
                                      // required: "Approx Hours is required",
                                    })}
                                  />
                                  {errors.AprxHours && (
                                    <div className="error">
                                      {errors.AprxHours.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6 ">
                                  <label className="form-label">
                                    Approx Minutes{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Minutes"
                                    disabled={isSubtaskDisabled()}
                                    {...register("AprxMinutes", {
                                      max: {
                                        value: 59,
                                        message:
                                          "approx minutes must be less than 60",
                                      },
                                      // required: "Approx Minutes is required",
                                    })}
                                  />
                                  {errors.AprxMinutes && (
                                    <div className="error">
                                      {errors.AprxMinutes.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                {subtaskId && (
                                  <div className="mb-4 col-md-2 col-12 d-flex align-items-end">
                                    <label
                                      className=" pe-3"
                                      htmlFor="flexSwitchStock"
                                    >
                                      <strong>Done</strong>
                                    </label>
                                    <div className="form-check form-switch d-flex justify-content-center align-items-center ">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="flexSwitchStock"
                                        checked={isSubtaskDone}
                                        onClick={(e) => handelStatusChange(e)}
                                        disabled={isSubtaskDisabled()}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="mt-4 mb-4 d-flex justify-content-between">
                            <div className="left d-flex flex-wrap gap-3">
                              <div
                                className="  btn btn-outline-danger me-2"
                                onClick={() => {
                                  console.log(subtaskId);
                                  if (subtaskId) {
                                    navigateToTaskWithId(subtaskId);
                                    // navigate(`/update/task/${tID}?subTaskId=${subtaskId}`);
                                  } else {
                                    navigateToTaskWithoutId();
                                    // navigate(`/update/task/${tID}`);
                                  }
                                }}
                              >
                                Cancel
                              </div>
                              <div className="  rounded-circl notification-count">
                                <div
                                  className="btn btn-dark me-2"
                                  onClick={() => handleExternalSubmit()}
                                >
                                  Attachments
                                </div>
                                <div className="notification-count d-flex justify-content-center">
                                  {attachmentCount}
                                </div>
                              </div>
                              {/* <div className="  rounded-circl notification-count">
                                <a
                                  href="#!"
                                  className="btn btn-dark me-2"
                                  onClick={() => setTab("notifications")}
                                >
                                  Notifications
                                </a>
                                <div className="notification-count">24</div>
                              </div> */}
                            </div>
                            <div className="right">
                              <button
                                className="btn btn-primary  "
                                disabled={isSubtaskDisabled()}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      );
                    case "attachments":
                      return (
                        <Attachment
                          setTab={setTab}
                          setAttachmentCount={setAttachmentCount}
                          setTitle={setTitle}
                          attachmentType={"subTask"}
                          TranType={8}
                          AttchType={1}
                        />
                      );

                    case "notifications":
                      return <></>;
                    // case "attachments":
                    //   return <Attachments />;
                    // case "notifications":
                    //   return <Notifications />;
                    default:
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default AddUpdateSubtask;
